import { SpinnerIcon } from "../../../assets/icons"
import cx from "classnames"

import type { SpinnerSize } from "./types"

import styles from "./index.module.css"
import { SPINNER_SIZE } from "./types"

export type SpinnerProps = {
  size?: SpinnerSize
}

export const Spinner = ({ size = "l" }: SpinnerProps) => {
  const spinnerClass = cx(styles.spinner, styles[SPINNER_SIZE[size]])

  return (
    <span className={spinnerClass}>
      <SpinnerIcon />
    </span>
  )
}
